
import {
  Users,
  Zap,
  Flame,
  PoundSterling,
  TrendingUp,
  CircleDollarSign,
  Activity,
} from "lucide-react";

import useLeads from "../hooks/useLeads";
import { Link } from "react-router-dom";
export default function DashboardPage() {

  // Correctly destructure hook
  const { leads = [], loading } = useLeads();

  
const user = JSON.parse(
  localStorage.getItem("user")
);

  // =========================
  // Dashboard Calculations
  // =========================

  const totalLeads = leads.length;

  const electricityLeads = leads.filter(
    (lead) =>
      lead.validation_type === "elec" 
    
  ).length;

  const gasLeads = leads.filter(
    (lead) =>
      lead.validation_type === "gas" 
    
  ).length;

  const bothLeads = leads.filter(
    (lead) =>
      lead.validation_type === "both"
   
  ).length;
 

  // =========================
  // Stats Cards
  // =========================

  const stats = [
    {
      label: "Total Leads",
      value: totalLeads,
      trend: "+12%",
      icon: <Users size={22} />,
      bg: "bg-blue-500",
    },
    {
      label: "Electricity Leads",
      value: electricityLeads,
      trend: "+8%",
      icon: <Zap size={22} />,
      bg: "bg-yellow-500",
    },
    {
      label: "Gas Leads",
      value: gasLeads,
      trend: "+5%",
      icon: <Flame size={22} />,
      bg: "bg-orange-500",
    },
    {
      label: "Electricity and Gas",
      value:  bothLeads,
      trend: "+21%",
      icon: <PoundSterling size={22} />,
      bg: "bg-green-500",
    },
  ];

  // =========================
  // Recent Leads
  // =========================

  const recentLeads = leads.slice(0, 5);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-xl font-semibold">
        Loading Dashboard...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 p-6">

      {/* Header */}
      <div className="flex items-center justify-between mb-8">

        <div>
          <h1 className="text-3xl font-bold text-slate-800">
            Dashboard
          </h1>

          <p className="text-slate-500 mt-1">
            Welcome back 👋
            <span className="text-sm font-semibold text-slate-700">
  {user?.first_name?.charAt(0).toUpperCase() +
    user?.first_name?.slice(1)}
</span>
          </p>
        </div>
        {user.role === "admin" || user.role==="agent" &&
<Link to="/leads/new">

 <button className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded-xl shadow-md transition">
          + Create Lead
        </button>
</Link>
} 
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">

        {stats.map((item) => (
          <div
            key={item.label}
            className="bg-white rounded-2xl shadow-sm p-5 border border-slate-200 hover:shadow-md transition"
          >

            <div className="flex items-center justify-between">

              <div>
                <p className="text-sm text-slate-500 font-medium">
                  {item.label}
                </p>

                <h2 className="text-3xl font-bold text-slate-800 mt-2">
                  {item.value}
                </h2>
              </div>

              <div
                className={`${item.bg} text-white w-12 h-12 rounded-xl flex items-center justify-center`}
              >
                {item.icon}
              </div>
            </div>

            <div className="flex items-center gap-1 mt-4 text-green-600 text-sm font-medium">
              <TrendingUp size={16} />
              {item.trend} this month
            </div>

          </div>
        ))}
      </div>

      {/* Charts + Analytics */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">

        {/* Revenue */}
        <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm border border-slate-200 p-6">

          <div className="flex items-center justify-between mb-6">

            <div>
              <h2 className="text-lg font-semibold text-slate-800">
                Revenue Overview
              </h2>

              <p className="text-sm text-slate-500">
                Monthly Lead performance
              </p>
            </div>

            <CircleDollarSign className="text-green-500" />
          </div>

          {/* Fake Chart */}
          <div className="h-64 flex items-end gap-4">

            {[40, 65, 55, 80, 70, 95, 75].map(
              (height, index) => (
                <div
                  key={index}
                  className="flex-1 bg-blue-500 rounded-t-xl"
                  style={{ height: `${height}%` }}
                ></div>
              )
            )}
          </div>

          <div className="flex justify-between mt-4 text-xs text-slate-400">
            <span>Mon</span>
            <span>Tue</span>
            <span>Wed</span>
            <span>Thu</span>
            <span>Fri</span>
            <span>Sat</span>
            <span>Sun</span>
          </div>
        </div>

        {/* Activity */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">

          <div className="flex items-center justify-between mb-6">

            <div>
              <h2 className="text-lg font-semibold text-slate-800">
                Activity
              </h2>

              <p className="text-sm text-slate-500">
                Latest CRM updates
              </p>
            </div>

            <Activity className="text-blue-500" />
          </div>

          <div className="space-y-5">

            <div className="border-l-4 border-blue-500 pl-4">
              <p className="text-sm font-medium text-slate-700">
                New electricity lead added
              </p>

              <p className="text-xs text-slate-400">
                2 mins ago
              </p>
            </div>

            <div className="border-l-4 border-green-500 pl-4">
              <p className="text-sm font-medium text-slate-700">
                Commission updated
              </p>

              <p className="text-xs text-slate-400">
                10 mins ago
              </p>
            </div>

            <div className="border-l-4 border-yellow-500 pl-4">
              <p className="text-sm font-medium text-slate-700">
                Lead moved to callback
              </p>

              <p className="text-xs text-slate-400">
                25 mins ago
              </p>
            </div>

            <div className="border-l-4 border-orange-500 pl-4">
              <p className="text-sm font-medium text-slate-700">
                New gas contract created
              </p>

              <p className="text-xs text-slate-400">
                1 hour ago
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* Recent Leads */}
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">

        <div className="flex items-center justify-between px-6 py-5 border-b border-slate-200">

          <div>
            <h2 className="text-lg font-semibold text-slate-800">
              Recent Leads
            </h2>

            <p className="text-sm text-slate-500">
              Latest submitted leads
            </p>
          </div>
<Link to="/leadslist">
<button className="text-blue-600 hover:text-blue-700 text-sm font-medium">
            View All
          </button>
</Link>
          
        </div>

        <div className="overflow-x-auto">

          <table className="w-full">

            <thead className="bg-slate-50">

              <tr className="text-left text-sm text-slate-500">
                <th className="px-6 py-4">Company</th>
                <th className="px-6 py-4">Type</th>
                <th className="px-6 py-4">Status</th>
                <th className="px-6 py-4">Date</th>
              </tr>
            </thead>

            <tbody>

              {recentLeads.map((lead) => (

                <tr
                  key={lead.id}
                  className="border-t border-slate-100 hover:bg-slate-50 transition"
                >

                  <td className="px-6 py-4 font-medium text-slate-700">
                    {lead.business_name}
                  </td>

                  <td className="px-6 py-4 text-slate-600 capitalize">
                    {lead.validation_type}
                  </td>

                  <td className="px-6 py-4 text-slate-600">
                    {lead.lead_disposition}
                  </td>

                  <td className="px-6 py-4 text-slate-600">
                    {new Date(lead.lead_date).toLocaleDateString()}
                  </td>

                </tr>
              ))}

            </tbody>

          </table>
        </div>
      </div>
    </div>
  );
}